import React from 'react'
import { useState } from '@hookstate/core'
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState'
import { useLanguageState } from '../../globalStates/LanguageState'
import { getElementFieldValueWithLanguage, makeSetHandlerWithLanguage, useLanguageSwitch } from '../../utils/Language'
import Description from '../description'

const ConsentContentSection: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const organizationState = useExhibitorDataState().getOrganization()
    const organization = useState(organizationState)
    const isMonoLingual = branding.configuration.monoLingual ? 'De' : 'En'
    const { currentLanguage, onChangeLanguageHandler } = useLanguageSwitch(isMonoLingual);

    return (
        <Description
            baseId="consent_description"
            title={branding.configuration.profilePage.sctConsentContent.lblConsentContent}
            labelLongdescription={branding.configuration.profilePage.sctConsentContent.lblConsentTitle}
            placeholderLongdescription={branding.configuration.profilePage.sctConsentContent.hntConsentTitle}
            labelShortdescription={branding.configuration.profilePage.sctConsentContent.lblConsentText}
            placeholderShortdescription={branding.configuration.profilePage.sctConsentContent.hntConsentText}
            valueLongDescription={getElementFieldValueWithLanguage(organization, "consentTitle", currentLanguage)}
            valueShortDescription={getElementFieldValueWithLanguage(organization, "consentText", currentLanguage)}
            language={currentLanguage}
            onChangeLongDescription={makeSetHandlerWithLanguage(organization, 'consentTitle', currentLanguage)}
            onChangeShortDescription={makeSetHandlerWithLanguage(organization, 'consentText', currentLanguage)}
            onChangeLanguage={onChangeLanguageHandler}
        />
    );
}

export default ConsentContentSection
